<div class="sidebar-xs sidebar-mobile-secondary">
    <div class="page-container" appFullHeight>
        <div class="page-content">
            <div class="navbar navbar-default navbar-static-top header-highlight">
                <div class="navbar-header">
                    <a class="navbar-brand hidden-xs" href="/"></a>
                    <ul class="nav navbar-nav pull-left visible-xs-block mobile-nav">
                        <li><a ui-sref="app.map" ui-sref-active="active" (click)="navigatePage('map')">Map</a></li>
                        <li><a ui-sref="app.fleet" ui-sref-active="active" (click)="navigatePage('fleet')">Fleet</a></li>
                        <li><a ui-sref="app.trip" ui-sref-active="active" (click)="navigatePage('trip')">Trip</a></li>
                        <li><a ui-sref="app.report" ui-sref-active="active" (click)="navigatePage('report')">Report</a></li>
                    </ul>
                    <ul class="nav navbar-nav pull-right visible-xs-block">
                        <li><a ui-sref-active="active" (click)="logout()"><i class="fa fa-sign-out"></i></a></li>
                    </ul>
                </div>
            </div>
			<app-sidebar class="sidebar sidebar-main sidebar-custom"></app-sidebar>
			<app-fleet-list class="sidebar sidebar-secondary sidebar-default sidebar-custom" *ngIf="currentRoute == '/map'"></app-fleet-list>
			<div class="content-wrapper">
				<app-map *ngIf="currentRoute == '/map'"></app-map>
				<app-vehicles *ngIf="currentRoute == '/fleet'"></app-vehicles>
				<app-report *ngIf="currentRoute == '/report'"></app-report>
			</div>
			<app-right-counter class="sidebar sidebar-third"></app-right-counter>
            <!--<div class="sidebar sidebar-secondary sidebar-default" ng-include="'assets/templates/partials/fleet-list.html'" ng-class="{'has-follow': $root.followVehicle, 'group-blank': !$root.vehicleFilter}">
            </div>-->            
        </div>
    </div>
</div>
<!--<div class="modal fade" tabindex="-1" role="dialog" id="masterAccount">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Choose an account:</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-3" ng-repeat="supername in supernames">
                        <button class="btn btn-lg btn-block btn-primary" (click)="loginWithId(supername)">
                            {{supername}}
                        </button>
                        <br>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-lg btn-block btn-danger" (click)="logout()">
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>-->